﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';

import { AppConfig } from '../app.config';
import { AlertService } from './alert.service';
import { LoginControl } from './logincontrol.service';
import { LogService} from 'app/_services/logmanager.service';
import { GlobalsService } from 'app/_services/globals.service';

import { map } from 'rxjs/operators';

@Injectable()
export class AuthenticationService {

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private alertService: AlertService,
        private router: Router,
        private loginControl: LoginControl,
        private globalStorage: GlobalsService
    ) { }

    login(token: string, debug = false) {
        if (token === '') {
            const stuser = this.globalStorage.getItem('currentUser');
            if (stuser !== '') {
                const current_user = JSON.parse(this.globalStorage.getItem('currentUser'));
            }
        }

        LogService.log('AuthenticationService', 'LOGIN', debug);
        LogService.log('AuthenticationService', token, debug);

        const ruta = this.config.apiUrl + this.config.sessionapi + '?token=' + token;
        return this.http.get<any>(ruta)
            .pipe(map((data) => {
                // login successful if there's a jwt token in the response
                LogService.log('AuthenticationService', 'Login -> ha tornat', debug);

                let logged = false;
                if (data) {
                    const user = data['data'];
                    LogService.log('AuthenticationService', user, debug);

                    if (user && user.username) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        this.globalStorage.setItem('currentUser', JSON.stringify(user));
                        logged =  true;
                    } else {
                        const basicinfo = {
                            'campusdir' : user.campusdir,
                            'imagedir' : user.imagedir
                        };
                        this.globalStorage.setItem('currentUser', JSON.stringify(basicinfo));
                        if (data.message) {
                            LogService.log('AuthenticationService', 'Login -> ' + data.message, debug);
                            this.alertService.error(data.message);
                        } else {
                            LogService.log('AuthenticationService', 'login -> Error 3', debug);
                            this.alertService.error('No heu entrat al sistema.');
                        }
                    }
                } else {
                    LogService.log('AuthenticationService', 'login -> Error 2', debug);
                    this.alertService.error('Error en accedir a la connexió del campus.');
                }
                this.loginControl.setloggedin(logged);
                this.loginControl.setcheckedsession(true);
                if (this.globalStorage.getItem('secretaria') !== '') {
                    this.loginControl.setcheckedsecretaria(true);
                }

             }));
     }

    checkSession(token: string, debug = false) {
        const ruta = this.config.apiUrl + this.config.sessionapi + '?token=' + token;
        return this.http.get<any>(ruta)
            .pipe(map((data) => {
                // login successful if there's a jwt token in the response
                LogService.log('AuthenticationService', 'CheckSession -> ha vuelto', debug);

                let logged = false;
                if (data) {
                    const user = data['data'];
                    LogService.log('AuthenticationService', user, debug);

                    if (user && user.username) {
                        // store user details and jwt token in local storage to keep user logged in between page refreshes
                        LogService.log('AuthenticationService', 'CheckSession -> loginado', debug);
                        this.globalStorage.setItem('currentUser', JSON.stringify(user));
                        logged =  true;
                    } else {
                        const basicinfo = {
                            'campusdir' : user.campusdir,
                            'imagedir' : user.imagedir
                        };
                        this.globalStorage.setItem('currentUser', JSON.stringify(basicinfo));
                        if (data.message) {
                            LogService.log('AuthenticationService', 'checkSession -> ' + data.message, debug);
                        } else {
                            LogService.log('AuthenticationService', 'checkSession -> Error 3', debug);
                        }
                    }
                } else {
                    LogService.log('AuthenticationService', 'checkSession -> Error 2', debug);
                    this.alertService.error('Error en accedir a la connexió del campus.');
                }
                this.loginControl.setloggedin(logged);
                this.loginControl.setcheckedsession(true);
                if (this.globalStorage.getItem('secretaria') !== '') {
                    this.loginControl.setcheckedsecretaria(true);
                }
                if (!logged) {
                    LogService.log('AuthenticationService', 'checkSession -> redirección a login', debug);
                    this.router.navigate(['/login']);
                }
             }));
     }

    logout() {
        // remove user from local storage to log user out
        this.globalStorage.clear();
    }
}
